import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Flame } from 'lucide-react';
export function PricingSection() {
  const [timeLeft, setTimeLeft] = useState({
    h: 1,
    m: 32,
    s: 7
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.s > 0) return {
          ...prev,
          s: prev.s - 1
        };
        if (prev.m > 0) return {
          ...prev,
          m: prev.m - 1,
          s: 59
        };
        if (prev.h > 0) return {
          ...prev,
          h: prev.h - 1,
          m: 59,
          s: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const timeBlocks = [{
    value: timeLeft.h,
    label: 'Horas'
  }, {
    value: timeLeft.m,
    label: 'Minutos'
  }, {
    value: timeLeft.s,
    label: 'Segundos'
  }];
  return <section id="pricing" className="relative overflow-hidden bg-white pt-[30px] pb-[30px]" data-id="element-118">
      <div className="container mx-auto px-4 max-w-2xl text-center relative z-10" data-id="element-119">
        <span className="inline-block px-6 py-2.5 mb-6 rounded-full border border-[#1a2e5a]/10 bg-[#f8f8f8] text-[#1a2e5a] font-bold tracking-[0.1em] uppercase text-xs" data-id="element-120">
          OFERTA ESPECIAL DE LANZAMIENTO
        </span>

        <div className="relative inline-block mb-8 w-full max-w-md mx-auto" data-id="element-121">
          <div className="rounded-3xl p-10 shadow-lg border-4 border-[#f9d6e3] bg-[#FDEEF3]" data-id="element-122">
            <h4 className="text-3xl font-extrabold text-[#1a2e5a] mb-2" data-id="element-123">
              La Agenda del
            </h4>
            <h4 className="text-4xl font-extrabold text-[#e5951b]" data-id="element-124">
              Nivel Inicial
            </h4>
          </div>
          <div className="absolute -top-4 -right-4 md:-top-6 md:-right-6 w-28 h-28 md:w-32 md:h-32 flex items-center justify-center" data-id="element-125">
            <div className="absolute inset-0 bg-[#e11d48] rotate-12 rounded-full shadow-lg" data-id="element-126" />
            <div className="relative text-center text-white leading-none rotate-12" data-id="element-127">
              <div className="text-3xl md:text-4xl font-extrabold" data-id="element-128">73%</div>
              <div className="text-[10px] md:text-[11px] font-bold tracking-wide mt-1" data-id="element-129">
                OFF
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="comprar" className="container mx-auto px-4 max-w-md relative z-10 scroll-mt-6 pt-[20px] pb-[40px]" data-id="element-130">
        <div className="bg-[#f8f8f8] rounded-3xl shadow-xl border border-slate-200 p-8 md:p-10 text-center" data-id="element-131">
          <div className="text-slate-500 text-lg md:text-xl mb-4 font-medium" data-id="element-132">
            <span className="line-through" data-id="element-133">Valor Real: $49.900 ARS</span>
          </div>

          <div className="inline-flex items-center gap-2 bg-[#f9d6e3] text-[#1a2e5a] font-bold px-6 py-3 rounded-full text-sm mb-6 shadow-sm" data-id="element-134">
            <Flame className="w-5 h-5 text-[#e5951b]" data-id="element-135" /> OFERTA POR TIEMPO
            LIMITADO
          </div>

          <div className="font-heading text-6xl md:text-7xl font-extrabold text-[#1a2e5a] leading-none mb-4" data-id="element-136">
            $19.990
          </div>
          <p className="text-slate-600 font-medium text-base mb-8" data-id="element-137">
            Pago único. Acceso para siempre.
          </p>

          <div className="flex justify-center gap-4 mb-8" data-id="element-138">
            {timeBlocks.map(block => <div key={block.label} className="bg-[#fdeef3] text-[#1a2e5a] rounded-2xl px-4 py-4 min-w-[90px] border border-[#f9d6e3] shadow-sm" data-id="element-139">
                <div className="font-heading text-4xl md:text-5xl font-bold leading-none" data-id="element-140">
                  {String(block.value).padStart(2, '0')}
                </div>
                <div className="text-[11px] font-bold tracking-[0.1em] uppercase mt-2 text-[#e5951b]" data-id="element-141">
                  {block.label}
                </div>
              </div>)}
          </div>

          <motion.a href="https://nivel-inicial.impultienda.ar/checkout" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="flex items-center justify-center gap-3 w-full bg-[#f5c842] hover:bg-[#e5b832] text-[#1a2e5a] font-extrabold text-lg md:text-xl px-8 py-6 rounded-xl shadow-lg shadow-[#f5c842]/30 transition-colors mb-6" data-id="element-142">
            <span className="flex items-center gap-2 text-center" data-id="element-143">
              🚀 ¿QUIERO MI MEGAPACK!
            </span>
          </motion.a>

          <div className="flex flex-col items-center gap-3 text-sm text-slate-600 font-semibold" data-id="element-144">
            <span data-id="element-145">
              <span aria-hidden="true" data-id="element-146">🔒</span> Pago 100% seguro. Entrega
              inmediata por email.
            </span>
          </div>
        </div>
      </div>
    </section>;
}